//React
import { useContext, useEffect } from "react";
//Componentes externos
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
//Componentes
import { Wrapper } from "../../components/Wrapper/Wrapper";
//Contexts
import { AuthContext } from "../../context/AuthContext";
import { ThemeProvider } from "../../components/ThemeContext/ThemeContext";
import { BloquesProvider } from "../../context/BloquesContext";
//Screens
import { LoginScreen } from "../LoginScreen/LoginScreen";
import ConfianzaListaScreen from "../ConfianzaListaScreen/ConfianzaListaScreen";
import { RolListaScreen } from "../Roles/RolListaScreen/RolListaScreen";
import { RolCrearScreen } from "../Roles/RolCrearScreen/RolCrearScreen";
import { RolEditarScreen } from "../Roles/RolEditarScreen/RolEditarScreen";
import { UsuarioListaScreen } from "../Usuarios/UsuarioListaScreen/UsuarioListaScreen";
import { UsuarioCrearScreen } from "../Usuarios/UsuarioCrearScreen/UsuarioCrearScreen";
import { UsuarioEditarScreen } from "../Usuarios/UsuarioEditarScreen/UsuarioEditarScreen";
import { DatosGenerales } from "../Evaluados/DatosGenerales/DatosGenerales";

import { FormatosGeneralesListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/FormatosGeneralesListaScreen/FormatosGeneralesListaScreen";
import { ConstanciaInasistenciaListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ConstanciaInasistencia/ConstanciaInasistenciaListaScreen";
import { ConstanciaInasistenciaCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ConstanciaInasistencia/ConstanciaInasistenciaCrearScreen";
import { ConstanciaInasistenciaEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ConstanciaInasistencia/ConstanciaInasistenciaEditarScreen";
import { CartaConfidencialidadListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/CartaConfidencialidad/CartaConfidencialidadListaScreen";
import { CartaConfidencialidadCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/CartaConfidencialidad/CartaConfidencialidadCrearScreen";
import { CartaConfidencialidadEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/CartaConfidencialidad/CartaConfidencialidadEditarScreen";
import { EnvioResultadosListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/EnvioResultados/EnvioResultadosListaScreen";
import { EnvioResultadosCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/EnvioResultados/EnvioResultadosCrearScreen";
import { EnvioResultadosEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/EnvioResultados/EnvioResultadosEditarScreen";
import { AutorizacionProporcionarDocumentosListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionProporcionarDocumentos/AutorizacionProporcionarDocumentosListaScreen";
import { AutorizacionProporcionarDocumentosCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionProporcionarDocumentos/AutorizacionProporcionarDocumentosCrearScreen";
import { AutorizacionProporcionarDocumentosEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionProporcionarDocumentos/AutorizacionProporcionarDocumentosEditarScreen";
import { FichaIdentificacionListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/FichaIdentificacion/FichaIdentificacionListaScreen";
import { FichaIdentificacionCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/FichaIdentificacion/FichaIdentificacionCrearScreen";
import { FichaIdentificacionEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/FichaIdentificacion/FichaIdentificacionEditarScreen";
import { ProtestaFotocopiasListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ProtestaFotocopias/ProtestaFotocopiasListaScreen";
import { ProtestaFotocopiasCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ProtestaFotocopias/ProtestaFotocopiasCrearScreen";
import { ProtestaFotocopiasEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/ProtestaFotocopias/ProtestaFotocopiasEditarScreen";
import { RequisitosPruebasListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/RequisitosPruebas/RequisitosPruebasListaScreen";
import { RequisitosPruebasCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/RequisitosPruebas/RequisitosPruebasCrearScreen";
import { RequisitosPruebasEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/RequisitosPruebas/RequisitosPruebasEditarScreen";
import { AutorizacionEvaluacionesListaScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionEvaluaciones/AutorizacionEvaluacionesListaScreen";
import { AutorizacionEvaluacionesCrearScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionEvaluaciones/AutorizacionEvaluacionesCrearScreen";
import { AutorizacionEvaluacionesEditarScreen } from "../Evaluaciones/EnLinea/FormatosGenerales/AutorizacionEvaluaciones/AutorizacionEvaluacionesEditarScreen";
import { SocioeconomicaListaScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/SocioeconomicaListaScreen/SocioeconomicaListaScreen";
import { AutorizacionSECrearScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/AutorizacionSE/AutorizacionSECrearScreen";
import { AutorizacionSEEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/AutorizacionSE/AutorizacionSEEditarScreen";
import { AutorizacionSEListaScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/AutorizacionSE/AutorizacionSEListaScreen";
import { EvaluacionPatrimonial1CrearScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/EvaluacionPatrimonial1/EvaluacionPatrimonial1CrearScreen";
import { EvaluacionPatrimonial1EditarScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/EvaluacionPatrimonial1/EvaluacionPatrimonial1EditarScreen";
import { EvaluacionPatrimonial1ListaScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/EvaluacionPatrimonial1/EvaluacionPatrimonial1ListaScreen";

import { ConclusionesSECrearScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/ConclusionesSE/ConclusionesSECrearScreen";
import { ConclusionesSEEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/ConclusionesSE/ConclusionesSEEditarScreen";
import { ConclusionesSEListaScreen } from "../Evaluaciones/EnLinea/EvaluacionSocioeconomica/ConclusionesSE/ConclusionesSEListaScreen";
import { DomiciliariaListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/DomiciliariaListaScreen/DomiciliariaListaScreen";
import { PsicologicaListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/PsicologicaListaScreen/PsicologicaListaScreen";
import { AutorizacionPSCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/AutorizacionPS/AutorizacionPSCrearScreen";
import { AutorizacionPSEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/AutorizacionPS/AutorizacionPSEditarScreen";
import { AutorizacionPSListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/AutorizacionPS/AutorizacionPSListaScreen";
import { EvaluacionPsicologica1CrearScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/EvaluacionPsicologica1/EvaluacionPsicologica1CrearScreen";
import { EvaluacionPsicologica1EditarScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/EvaluacionPsicologica1/EvaluacionPsicologica1EditarScreen";
import { EvaluacionPsicologica1ListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/EvaluacionPsicologica1/EvaluacionPsicologica1ListaScreen";
import { ConclusionesPSCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/ConclusionesPS/ConclusionesPSCrearScreen";
import { ConclusionesPSEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/ConclusionesPS/ConclusionesPSEditarScreen";
import { ConclusionesPSListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/ConclusionesPS/ConclusionesPSListaScreen";
import { PsicometricaListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/PsicometricaListaScreen/PsicometricaListaScreen";
import { AutorizacionPSMListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/AutorizacionPSM/AutorizacionPSMListaScreen";
import { AutorizacionPSMCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/AutorizacionPSM/AutorizacionPSMCrearScreen";
import { AutorizacionPSMEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/AutorizacionPSM/AutorizacionPSMEditarScreen";
import { ConclusionesPSMListaScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/ConclusionesPSM/ConclusionesPSMListaScreen";
import { ConclusionesPSMCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/ConclusionesPSM/ConclusionesPSMCrearScreen";
import { ConclusionesPSMEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionPsicometrica/ConclusionesPSM/ConclusionesPSMEditarScreen";
import { PoligrafoListaScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/PoligrafoListaScreen/PoligrafoListaScreen";
import { MedicaListaScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/MedicaListaScreen/MedicaListaScreen";
import { AutorizacionMCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/AutorizacionM/AutorizacionMCrearScreen";
import { AutorizacionMEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/AutorizacionM/AutorizacionMEditarScreen";
import { AutorizacionMListaScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/AutorizacionM/AutorizacionMListaScreen";
import { ConclusionMCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/ConclusionM/ConclusionMCrearScreen";
import { ConclusionMEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/ConclusionM/ConclusionMEditarScreen";
import { ConclusionMListaScreen } from "../Evaluaciones/EnLinea/EvaluacionMedica/ConclusionM/ConclusionMListaScreen";
import { ToxicologicaListaScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ToxicologicaListaScreen/ToxicologicaListaScreen";
import { AutorizacionTXCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/AutorizacionTX/AutorizacionTXCrearScreen";
import { AutorizacionTXEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/AutorizacionTX/AutorizacionTXEditarScreen";
import { AutorizacionTXListaScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/AutorizacionTX/AutorizacionTXListaScreen";
import { ConclusionesTXCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ConclusionesTX/ConclusionesTXCrearScreen";
import { ConclusionesTXEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ConclusionesTX/ConclusionesTXEditarScreen";
import { ConclusionesTXListaScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ConclusionesTX/ConclusionesTXListaScreen";
import { ReporteExamenTXCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ReporteExamenTX/ReporteExamenTXCrearScreen";
import { ReporteExamenTXEditarScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ReporteExamenTX/ReporteExamenTXEditarScreen";
import { ReporteExamenListaScreen } from "../Evaluaciones/EnLinea/EvaluacionToxicologica/ReporteExamenTX/ReporteExamenTXListaScreen";
import { InformacionListaScreen } from "../Evaluaciones/EnLinea/ReporteGeneralAreaAnalisisInfo/InformacionListaScreen/InformacionListaScreen";
import { InfoFamiliarCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/InfoFamiliarListaScreen/InfoFamiliarCrearScreen";
import { InfoFamiliarEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/InfoFamiliarListaScreen/InfoFamiliarEditarScreen";
import { EvaluadosListaScreen } from "../Evaluados/EvaluadosListaScreen/EvaluadosListaScreen";
import { EvaluadosCrearScreen } from "../Evaluados/EvaluadosCrearScreen/EvaluadosCrearScreen";
import { EvaluadosEditarScreen } from "../Evaluados/EvaluadosEditarScreen/EvaluadosEditarScreen";
import { EmpresasListaScreen } from "../Empresas/EmpresasListaScreen/EmpresasListaScreen";
import { EmpresasCrearScreen } from "../Empresas/EmpresasCrearScreen/EmpresasCrearScreen";
import { ModulosListaScreen } from "../Evaluaciones/EnLinea/ModulosListScreen/ModulosListScreen";
import { AutorizacionVDListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/AutorizacionVDListaScreen/AutorizacionVDListaScreen";
import { AutorizacionVDCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/AutorizacionVDListaScreen/AutorizacionVDCrearScreen";
import { AutorizacionVDEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/AutorizacionVDListaScreen/AutorizacionVDEditarScreen";
import { BienesListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/BienesListaScreen/BienesListaScreen";
import { BienesCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/BienesListaScreen/BienesCrearScreen";
import { BienesEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/BienesListaScreen/BienesEditarScreen";
import { PropiedadListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PropiedadListaScreen/PropiedadListaScreen";
import { PropiedadCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PropiedadListaScreen/PropiedadCrearScreen";
import { PropiedadEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PropiedadListaScreen/PropiedadEditarScreen";
import { InfoFamiliarListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/InfoFamiliarListaScreen/InfoFamiliarListaScreen";
import { CroquisListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/CroquisListaScreen/CroquisListaScreen";
import { CroquisCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/CroquisListaScreen/CroquisCrearScreen";
import { CroquisEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/CroquisListaScreen/CroquisEditarScreen";
import { LaboralesListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/LaboralesListaScreen/LaboralesListaScreen";
import { LaboralesCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/LaboralesListaScreen/LaboralesCrearScreen";
import { LaboralesEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/LaboralesListaScreen/LaboralesEditarScreen";
import { PersonalesListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PersonalesListaScreen/PersonalesListaScreen";
import { PersonalesCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PersonalesListaScreen/PersonalesCrearScreen";
import { PersonalesEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/PersonalesListaScreen/PersonalesEditarScreen";
import { VecinalesListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/VecinalesListaScreen/VecinalesListaScreen";
import { VecinalesCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/VecinalesListaScreen/VecinalesCrearScreen";
import { VecinalesEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/VecinalesListaScreen/VecinalesEditarScreen";
import { FotosListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/FotosListaScreen/FotosListaScreen";
import { FotosCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/FotosListaScreen/FotosCrearScreen";
import { FotosEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/FotosListaScreen/FotosEditarScreen";
import { ConclusionesDomListaScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/ConclusionesDomListaScreen/ConclusionesDomListaScreen";
import { ConclusionesDomCrearScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/ConclusionesDomListaScreen/ConclusionesDomCrearScreen";
import { ConclusionesDomEditarScreen } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/ConclusionesDomListaScreen/ConclusionesDomEditarScreen";
import { DescargarFormulariosVD_print } from "../Evaluaciones/EnLinea/VisitaDomiciliaria/DescargarFormulariosVD/DescargarFormulariosVD_print";
import { MenuTipoModulo } from "../Evaluaciones/MenuTipoModulo/MenuTipoModulo";
import { AutorizacionDRListaScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/AutorizacionDR/AutorizacionDRListaScreen";
import { AutorizacionDRCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/AutorizacionDR/AutorizacionDRCrearScreen";
import { AutorizacionDREditarScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/AutorizacionDR/AutorizacionDREditarScreen";
import { ConclusionesDRListaScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/ConclusionesDRListaScreen/ConclusionesDRListaScreen";
import { ConclusionesDRCrearScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/ConclusionesDRListaScreen/ConclusionesDRCrearScreen";
import { ConclusionesDREditarScreen } from "../Evaluaciones/EnLinea/EvaluacionDeteccionRiesgos/ConclusionesDRListaScreen/ConclusionesDREditarScreen";

import { ResultadoGeneralRGAAI } from "../Evaluaciones/EnLinea/ReporteGeneralAreaAnalisisInfo/ResultadoGeneralRGAAI/ResultadoGeneralRGAAI";
import { ResultadoGeneralRGAAICrearScreen } from "../Evaluaciones/EnLinea/ReporteGeneralAreaAnalisisInfo/ResultadoGeneralRGAAI/ResultadoGeneralRGAAICrearScreen";
import { ResultadoGeneralRGAAIEditarScreen } from "../Evaluaciones/EnLinea/ReporteGeneralAreaAnalisisInfo/ResultadoGeneralRGAAI/ResultadoGeneralRGAAIEditarScreen";

import { OtrasEvaluacionesListaScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/OtrasEvaluacionesListaScreen/OtrasEvaluacionesListaScreen";
import { AutorizacionOEListaScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/AutorizacionOtrasEvaluaciones/AutorizacionOEListaScreen";
import { AutorizacionOECrearScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/AutorizacionOtrasEvaluaciones/AutorizacionOECrearScreen";
import { AutorizacionOEEditarScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/AutorizacionOtrasEvaluaciones/AutorizacionOEEditarScreen";
import { ConclusionesOEListaScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/ConclusionOtrasEvaluaciones/ConclusionesOEListaScreen";
import { ConclusionesOECrearScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/ConclusionOtrasEvaluaciones/ConclusionesOECrearScreen";
import { ConclusionesOEEditarScreen } from "../Evaluaciones/EnLinea/OtrasEvaluacionesLinea/ConclusionOtrasEvaluaciones/ConclusionesOEEditarScreen";

import { EnvioResultadosLineaListaScreen } from "../Evaluaciones/EnLinea/EnvioResultadosLinea/EnvioResultadosListaScreen/EnvioResultadosLineaListaScreen";

// Modulos Presencial
import { ModulosListaPresnecialScreen } from "../Evaluaciones/Presencial/ModulosListPresencialScreen/ModulosListPresScreen";
import { DocumentosListaPresencialScreen } from "../Evaluaciones/Presencial/Documentos/DocumentosListaPresencialScreen";
import { FormatosListaPresencialScreen } from "../Evaluaciones/Presencial/FormatosGeneralesPresencial/FormatosListaPresencialScreen";
import { MedicaListaPresencialScreen } from "../Evaluaciones/Presencial/EvaluacionMedicaPresencial/MedicaListaPresencialScreen";
import { DomiciliariaListaPresencialScreen } from "../Evaluaciones/Presencial/VisitaDomiciliariaPresencial/DomiciliariaListaPresencialScreen";
import { PsicologicaListaPresencialScreen } from "../Evaluaciones/Presencial/EvaluacionPsicologicaPresencial/PsicologicaListaPresencialScreen";
import { PsicometricaListaPresencialScreen } from "../Evaluaciones/Presencial/EvaluacionPsicometricaPresencial/PsicometricaListaPresencialScreen";
import { AnalisisDeInformacionListaPresencialScreen } from "../Evaluaciones/Presencial/AnalisisDeInformacionPresencial/AnalisisDeInformacionListaPresencialScreen";
import { SocioeconomicaListaPresencialScreen } from "../Evaluaciones/Presencial/InvestigacionSocioeconomicaPresencial/SocioeconomicaListaPresencialScreen";
import { ToxicologicaListaPresencialScreen } from "../Evaluaciones/Presencial/EvaluacionToxicologicaPresencial/ToxicologicaListaPresencialScreen";
import { DeteccionRiesgosListaPresencialScreen } from "../Evaluaciones/Presencial/EvaluacionDeteccionRiesgosPresencial/DeteccionRiesgosListaPresencialScreen";
import { OtrasEvaluacionesListaPresencial } from "../Evaluaciones/Presencial/OtrasEvaluacionesPresencial/OtrasEvaluacionesListaPresencial";
import { EnvioDeResultadosListaPresencial } from "../Evaluaciones/Presencial/EnvioDeResultadosPresencial/EnvioDeResultadosListaPresencial";
import { VerificacionDocumento } from "../VerificacionDocumento/VerificacionDocumento";
import { PoligrafoPresencial } from "../Evaluaciones/Presencial/PoligrafoPresencial/PoligrafoPresencial";
import { EyedetcPresencial } from "../Evaluaciones/Presencial/EyedetcPresencial/EyedetcPresencial";

//Estilos
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { EvaluacionPsicologica1ListaPrint } from "../Evaluaciones/EnLinea/EvaluacionPsicologica/EvaluacionPsicologica1/EvaluacionPsicologica1ListaPrint";
import { VeriEyePresencial } from "../Evaluaciones/Presencial/VeriEyePresencial/VeriEyePresencial";
import { VoiceStressAnalysis } from "../Evaluaciones/Presencial/VoiceStressAnalysis/VoiceStressAnalysis";
import { ReporteFinalPresencial } from "../Evaluaciones/Presencial/ReporteFinalPresencial/ReporteFinal/ReporteFinalPresencial";
import { CrearReporteFinalPresencial } from "../Evaluaciones/Presencial/ReporteFinalPresencial/ReporteFinalCRUDPresencial/ReporteFinalPresencialCrearScreen";
import { EditarReporteFinalPresencial } from "../Evaluaciones/Presencial/ReporteFinalPresencial/ReporteFinalCRUDPresencial/ReporteFinalPresencialEditarScreen";
import { ReporteFinalPresencialPrint } from "../Evaluaciones/Presencial/ReporteFinalPresencial/ReporteFinalCRUDPresencial/ReporteFinalPresencialPrint";
import { ReporteFinalPresencialListaScreen } from "../Evaluaciones/Presencial/ReporteFinalPresencial/ReporteFinalCRUDPresencial/ReporteFinalPresencialListaScreen";

/**
 * Screen App
 * @description: Es la pantalla que cubre a la App y que tiene definidos
 * los routes de navegación.
 * @date 01/10/2023.
 * @returns JSX del Screen.
 */
const App = () => {
  const queryClient = new QueryClient();
  
  /* ----------------------------- Hooks ------------------------------------*/
  // Se obtienen los valores del context
  const authContext = useContext(AuthContext);
  /* --------------------------- useEffect's --------------------------------*/
  //Se encarga de verificar si se está volviendo a ver la pestaña
  useEffect(() => {
    //Función para devolver el nombre cuando vuelve a cargar el componente
    const handleVisibilityChange = () => {
      document.title = "SkyClear";
    };
    //Eventos
    document.addEventListener("visibilitychange", handleVisibilityChange);
    //Return
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  //Se encarga de verificar si se está volviendo a ver la pestaña
  useEffect(() => {
    //Función para hacer logout si se es un usuario invitado y se cierra el tab
    const handleTabClose = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      if (authContext.isLoggedIn && authContext.rol === "Invitado") {
        authContext.logout();
      }
    };
    //Eventos
    window.addEventListener("beforeunload", handleTabClose);
    //Return
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [authContext]);
  /* -------------------------------- return --------------------------------*/
  //Return principal
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BloquesProvider>
          <div className="App">
            <Routes>
              {/* RUTAS PROTEGIDAS - SOLO CON AUTENTICACIÓN */}
              {authContext.isLoggedIn ? (
                <>
                  <Route path="/" element={<Wrapper />}>
                    <Route index element={<ConfianzaListaScreen />} />
                  </Route>

                  {/* Ruta de verificación de documentos (requiere sesión y permiso de verificación) */}
                  <Route path="verificar/*" element={<Wrapper />}>
                    <Route path="*" element={<VerificacionDocumento />} />
                  </Route>

                  {/* Ruta del rol */}
                  <Route path="rol" element={<Wrapper />}>
                    <Route index element={<RolListaScreen />} />
                    <Route path="crear" element={<RolCrearScreen />} />
                    <Route path="editar/:rolId" element={<RolEditarScreen />} />
                    <Route path=":usuarioList_id" />
                  </Route>

                  {/* Ruta del usuario */}
                  <Route path="usuario" element={<Wrapper />}>
                    <Route index element={<UsuarioListaScreen />} />
                    <Route path="crear" element={<UsuarioCrearScreen />} />
                    <Route
                      path="editar/:usuario_id"
                      element={<UsuarioEditarScreen />}
                    />
                  </Route>

                  {/* Ruta del Menu del tipo de modulo */}
                  <Route path="tipoModulo" element={<Wrapper />}>
                    <Route index element={<MenuTipoModulo />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<MenuTipoModulo />}
                    />
                  </Route>

                  {/* Ruta de Modulos */}
                  <Route path="modulos" element={<Wrapper />}>
                    <Route index element={<ModulosListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ModulosListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Datos Generales */}
                  <Route path="DatosGenerales" element={<Wrapper />}>
                    <Route index element={<DatosGenerales />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<DatosGenerales />}
                    />
                  </Route>

                  {/* Ruta de Formatos Generales */}
                  <Route path="formatosG" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<FormatosGeneralesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Constancia de inasistencia Lista*/}
                  <Route path="constanciaInasistencia" element={<Wrapper />}>
                    <Route
                      index
                      element={<ConstanciaInasistenciaListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConstanciaInasistenciaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Constancia de inasistencia Crear*/}
                  <Route
                    path="crearConstanciaInasistencia"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={<ConstanciaInasistenciaCrearScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConstanciaInasistenciaCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Constancia de inasistencia Editar*/}
                  <Route
                    path="editarConstanciaInasistencia"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={<ConstanciaInasistenciaEditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConstanciaInasistenciaEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Carta de Confidencialidad*/}
                  <Route path="cartaConfidencial" element={<Wrapper />}>
                    <Route
                      index
                      element={<CartaConfidencialidadListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<CartaConfidencialidadListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Carta de Confidencialidad*/}
                  <Route path="crearCartaConfidencial" element={<Wrapper />}>
                    <Route
                      index
                      element={<CartaConfidencialidadCrearScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<CartaConfidencialidadCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Carta de Confidencialidad*/}
                  <Route path="editarCartaConfidencial" element={<Wrapper />}>
                    <Route
                      index
                      element={<CartaConfidencialidadEditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<CartaConfidencialidadEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Envío de Resultados*/}
                  <Route path="envioResultados" element={<Wrapper />}>
                    <Route index element={<EnvioResultadosListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<EnvioResultadosListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Envío de Resultados Crear*/}
                  <Route path="crearEnvioResultados" element={<Wrapper />}>
                    <Route index element={<EnvioResultadosCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<EnvioResultadosCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Envío de Resultados Editar*/}
                  <Route path="editarEnvioResultados" element={<Wrapper />}>
                    <Route index element={<EnvioResultadosEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<EnvioResultadosEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización para Proporcionar Documentos e Información */}
                  <Route path="autorizacionProporcionar" element={<Wrapper />}>
                    <Route
                      index
                      element={
                        <AutorizacionProporcionarDocumentosListaScreen />
                      }
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={
                        <AutorizacionProporcionarDocumentosListaScreen />
                      }
                    />
                  </Route>

                  {/* Ruta de Crear Autorización para Proporcionar Documentos e Información */}
                  <Route
                    path="crearAutorizacionProporcionar"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={
                        <AutorizacionProporcionarDocumentosCrearScreen />
                      }
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={
                        <AutorizacionProporcionarDocumentosCrearScreen />
                      }
                    />
                  </Route>

                  {/* Ruta de Editar Autorización para Proporcionar Documentos e Información */}
                  <Route
                    path="editarAutorizacionProporcionar"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={
                        <AutorizacionProporcionarDocumentosEditarScreen />
                      }
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={
                        <AutorizacionProporcionarDocumentosEditarScreen />
                      }
                    />
                  </Route>

                  {/* Ruta de Ficha de Identificación*/}
                  <Route path="fichaIdentificacion" element={<Wrapper />}>
                    <Route index element={<FichaIdentificacionListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<FichaIdentificacionListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Crear Ficha de Identificación*/}
                  <Route path="crearFichaIdentificacion" element={<Wrapper />}>
                    <Route index element={<FichaIdentificacionCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<FichaIdentificacionCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Editar Ficha de Identificación*/}
                  <Route path="editarFichaIdentificacion" element={<Wrapper />}>
                    <Route
                      index
                      element={<FichaIdentificacionEditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<FichaIdentificacionEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Protesta para Fotocopias*/}
                  <Route path="protestaFotocopias" element={<Wrapper />}>
                    <Route index element={<ProtestaFotocopiasListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ProtestaFotocopiasListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Crear Protesta para Fotocopias*/}
                  <Route path="crearProtestaFotocopias" element={<Wrapper />}>
                    <Route index element={<ProtestaFotocopiasCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ProtestaFotocopiasCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Editar Protesta para Fotocopias*/}
                  <Route path="editarProtestaFotocopias" element={<Wrapper />}>
                    <Route index element={<ProtestaFotocopiasEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ProtestaFotocopiasEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Requisitos Para el Proceso de Pruebas de Confianza */}
                  <Route path="requisitosPruebas" element={<Wrapper />}>
                    <Route index element={<RequisitosPruebasListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<RequisitosPruebasListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Requisitos Para el Proceso de Pruebas de Confianza Crear */}
                  <Route path="crearRequisitosPruebas" element={<Wrapper />}>
                    <Route index element={<RequisitosPruebasCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<RequisitosPruebasCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Requisitos Para el Proceso de Pruebas de Confianza Editar */}
                  <Route path="editarRequisitosPruebas" element={<Wrapper />}>
                    <Route index element={<RequisitosPruebasEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<RequisitosPruebasEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización General al Proceso de Evaluación de Pruebas de Confianza */}
                  <Route path="autorizacionEvaluacion" element={<Wrapper />}>
                    <Route
                      index
                      element={<AutorizacionEvaluacionesListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionEvaluacionesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Crear Autorización General al Proceso de Evaluación de Pruebas de Confianza */}
                  <Route
                    path="crearAutorizacionEvaluacion"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={<AutorizacionEvaluacionesCrearScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionEvaluacionesCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Editar Autorización General al Proceso de Evaluación de Pruebas de Confianza */}
                  <Route
                    path="editarAutorizacionEvaluacion"
                    element={<Wrapper />}
                  >
                    <Route
                      index
                      element={<AutorizacionEvaluacionesEditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionEvaluacionesEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Investigación Socioeconomica */}
                  <Route path="socioeconomica" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<SocioeconomicaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Socioeconómicas Lista*/}
                  <Route path="autorizacionSE" element={<Wrapper />}>
                    <Route index element={<AutorizacionSEListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionSEListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Socioeconómicas Crear*/}
                  <Route path="crearAutSE" element={<Wrapper />}>
                    <Route index element={<AutorizacionSECrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionSECrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Socioeconómicas Editar*/}
                  <Route path="editarAutSE" element={<Wrapper />}>
                    <Route index element={<AutorizacionSEEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionSEEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Patrimonial 1 Lista*/}
                  <Route path="patrimonialSE" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPatrimonial1ListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPatrimonial1ListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Patrimonial 1 Crear*/}
                  <Route path="crearPatrimonialSE" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPatrimonial1CrearScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPatrimonial1CrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Patrimonial 1 Editar*/}
                  <Route path="editarPatrimonialSE" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPatrimonial1EditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPatrimonial1EditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Socioeconómicas Lista */}
                  <Route path="conclusionesSE" element={<Wrapper />}>
                    <Route index element={<ConclusionesSEListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesSEListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Socioeconómicas Crear */}
                  <Route path="crearconclusionesSE" element={<Wrapper />}>
                    <Route index element={<ConclusionesSECrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesSECrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Socioeconómicas Editar */}
                  <Route path="editarconclusionesSE" element={<Wrapper />}>
                    <Route index element={<ConclusionesSEEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesSEEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Visita domiciliaria */}
                  <Route path="domiciliaria" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<DomiciliariaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Psicologica */}
                  <Route path="psicologica" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PsicologicaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Lista*/}
                  <Route path="autorizacionPS" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Crear*/}
                  <Route path="crearAutPS" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Editar*/}
                  <Route path="editarAutPS" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Psicológica Lista*/}
                  <Route path="evaluacionPS1" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPsicologica1ListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPsicologica1ListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Psicológica Crear*/}
                  <Route path="crearEvaluacionPS1" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPsicologica1CrearScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPsicologica1CrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Psicológica Editar*/}
                  <Route path="editarEvaluacionPS1" element={<Wrapper />}>
                    <Route
                      index
                      element={<EvaluacionPsicologica1EditarScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EvaluacionPsicologica1EditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Psicológica Lista */}
                  <Route path="conclusionesPS" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSListaScreen />}
                    />
                    {/* Aqui va a ser ConclusionesDRListaScreen*/}
                  </Route>

                  {/* Ruta de Llenada de Conclusión Psicológica Crear */}
                  <Route path="crearconclusionesPS" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Psicológica Editar */}
                  <Route path="editarconclusionesPS" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Psicometrica */}
                  <Route path="psicometrica" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PsicometricaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión Psicometrica Lista */}
                  <Route path="conclusionPSM" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSMListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSMListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión Psicometrica Crear*/}
                  <Route path="crearConclusionPSM" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSMCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSMCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión Psicometrica Editar*/}
                  <Route path="editarConclusionPSM" element={<Wrapper />}>
                    <Route index element={<ConclusionesPSMEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesPSMEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización Psicometrica Lista */}
                  <Route path="autorizacionPSM" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSMListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSMListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización Psicometrica Crear*/}
                  <Route path="crearAutorizacionPSM" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSMCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSMCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización Psicometrica Editar*/}
                  <Route path="editarAutorizacionPSM" element={<Wrapper />}>
                    <Route index element={<AutorizacionPSMEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionPSMEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación de Poligrafo */}
                  <Route path="poligrafo" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PoligrafoListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Médica */}
                  <Route path="medica" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<MedicaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Lista*/}
                  <Route path="autorizacionM" element={<Wrapper />}>
                    <Route index element={<AutorizacionMListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionMListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Crear*/}
                  <Route path="crearAutM" element={<Wrapper />}>
                    <Route index element={<AutorizacionMCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionMCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Psicológicas Editar*/}
                  <Route path="editarAutM" element={<Wrapper />}>
                    <Route index element={<AutorizacionMEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionMEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Evaluaciones Médicas Lista*/}
                  <Route path="conclusionM" element={<Wrapper />}>
                    <Route index element={<ConclusionMListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionMListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Evaluaciones Médicas Crear*/}
                  <Route path="crearConclusionM" element={<Wrapper />}>
                    <Route index element={<ConclusionMCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionMCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Evaluaciones Médicas Editar*/}
                  <Route path="editarConclusionM" element={<Wrapper />}>
                    <Route index element={<ConclusionMEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionMEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluación Toxicológica */}
                  <Route path="toxicologica" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<ToxicologicaListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Toxicológicas Lista*/}
                  <Route path="autorizacionTX" element={<Wrapper />}>
                    <Route index element={<AutorizacionTXListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionTXListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Toxicológicas Crear*/}
                  <Route path="crearAutTX" element={<Wrapper />}>
                    <Route index element={<AutorizacionTXCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionTXCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones Toxicológicas Editar*/}
                  <Route path="editarAutTX" element={<Wrapper />}>
                    <Route index element={<AutorizacionTXEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionTXEditarScreen />}
                    />
                  </Route>

                  {/* Ruta Reporte Examen Trabajador Lista */}
                  <Route path="examenTX" element={<Wrapper />}>
                    <Route index element={<ReporteExamenListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ReporteExamenListaScreen />}
                    />
                  </Route>

                  {/* Ruta Reporte Examen Trabajador Crear */}
                  <Route path="crearexamenTX" element={<Wrapper />}>
                    <Route index element={<ReporteExamenTXCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ReporteExamenTXCrearScreen />}
                    />
                  </Route>

                  {/* Ruta Reporte Examen Trabajador Editar */}
                  <Route path="editarexamenTX" element={<Wrapper />}>
                    <Route index element={<ReporteExamenTXEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ReporteExamenTXEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Toxicológicas Lista */}
                  <Route path="conclusionesTX" element={<Wrapper />}>
                    <Route index element={<ConclusionesTXListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesTXListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Toxicológicas Crear */}
                  <Route path="crearconclusionesTX" element={<Wrapper />}>
                    <Route index element={<ConclusionesTXCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesTXCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Llenada de Conclusión Toxicológicas Editar */}
                  <Route path="editarconclusionesTX" element={<Wrapper />}>
                    <Route index element={<ConclusionesTXEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesTXEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Área de análisis de Información */}
                  <Route path="informacion" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<InformacionListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Evaluados */}
                  <Route path="/evaluadosList" element={<Wrapper />}>
                    <Route index element={<EvaluadosListaScreen />} />
                    <Route path="crear" element={<EvaluadosCrearScreen />} />
                    <Route
                      path="editar/:uuid"
                      element={<EvaluadosEditarScreen />}
                    />
                    <Route
                      path="evaluar/:evaluadosList_id"
                      element={<MenuTipoModulo />}
                    />
                  </Route>

                  {/* Ruta de Empresas */}
                  <Route path="empresas" element={<Wrapper />}>
                    <Route index element={<EmpresasListaScreen />} />
                    <Route path="crear" element={<EmpresasCrearScreen />} />
                  </Route>

                  {/* Ruta de Autorizacion al Proceso de Visita Domiciliaria Lista*/}
                  <Route path="autorizacionVD" element={<Wrapper />}>
                    <Route index element={<AutorizacionVDListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionVDListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion al Proceso de Visita Domiciliaria Crear*/}
                  <Route path="crearAutVD" element={<Wrapper />}>
                    <Route index element={<AutorizacionVDCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionVDCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion al Proceso de Visita Domiciliaria Editar*/}
                  <Route path="editarAutVD" element={<Wrapper />}>
                    <Route index element={<AutorizacionVDEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionVDEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Bienes Inmuebles / Muebles Lista */}
                  <Route path="bienes" element={<Wrapper />}>
                    <Route index element={<BienesListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<BienesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Bienes Inmuebles / Muebles Crear */}
                  <Route path="crearbienes" element={<Wrapper />}>
                    <Route index element={<BienesCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<BienesCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Bienes Inmuebles / Muebles Editar*/}
                  <Route path="editarbienes" element={<Wrapper />}>
                    <Route index element={<BienesEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<BienesEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Inmueble Casa, Departamento, Otro Lista */}
                  <Route path="propiedad" element={<Wrapper />}>
                    <Route index element={<PropiedadListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PropiedadListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Inmueble Casa, Departamento, Otro Crear */}
                  <Route path="crearpropiedad" element={<Wrapper />}>
                    <Route index element={<PropiedadCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PropiedadCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Inmueble Casa, Departamento, Otro Editar */}
                  <Route path="editarpropiedad" element={<Wrapper />}>
                    <Route index element={<PropiedadEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PropiedadEditarScreen />}
                    />
                  </Route>

                  {/* Información Familiar Lista*/}
                  <Route path="familiar" element={<Wrapper />}>
                    <Route index element={<InfoFamiliarListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<InfoFamiliarListaScreen />}
                    />
                  </Route>

                  {/* Información Familiar Crear*/}
                  <Route path="crearfamiliar" element={<Wrapper />}>
                    <Route index element={<InfoFamiliarCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<InfoFamiliarCrearScreen />}
                    />
                  </Route>

                  {/* Información Familiar Editar*/}
                  <Route path="editarfamiliar" element={<Wrapper />}>
                    <Route index element={<InfoFamiliarEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<InfoFamiliarEditarScreen />}
                    />
                  </Route>

                  {/* Croquis Domicilio Lista */}
                  <Route path="croquis" element={<Wrapper />}>
                    <Route index element={<CroquisListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<CroquisListaScreen />}
                    />
                  </Route>

                  {/* Croquis Domicilio Crear*/}
                  <Route path="crearcroquis" element={<Wrapper />}>
                    <Route index element={<CroquisCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<CroquisCrearScreen />}
                    />
                  </Route>

                  {/* Croquis Domicilio Editar*/}
                  <Route path="editarcroquis" element={<Wrapper />}>
                    <Route index element={<CroquisEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<CroquisEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias laborales Lista */}
                  <Route path="laborales" element={<Wrapper />}>
                    <Route index element={<LaboralesListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<LaboralesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias laborales Crear */}
                  <Route path="crearlaborales" element={<Wrapper />}>
                    <Route index element={<LaboralesCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<LaboralesCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias laborales Editar */}
                  <Route path="editarlaborales" element={<Wrapper />}>
                    <Route index element={<LaboralesEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<LaboralesEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias personales Lista */}
                  <Route path="personales" element={<Wrapper />}>
                    <Route index element={<PersonalesListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PersonalesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias personales Crear */}
                  <Route path="crearpersonales" element={<Wrapper />}>
                    <Route index element={<PersonalesCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PersonalesCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias personales Editar */}
                  <Route path="editarpersonales" element={<Wrapper />}>
                    <Route index element={<PersonalesEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<PersonalesEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias vecinales Lista*/}
                  <Route path="vecinales" element={<Wrapper />}>
                    <Route index element={<VecinalesListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<VecinalesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias vecinales Crear*/}
                  <Route path="crearvecinales" element={<Wrapper />}>
                    <Route index element={<VecinalesCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<VecinalesCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Referencias vecinales Editar*/}
                  <Route path="editarvecinales" element={<Wrapper />}>
                    <Route index element={<VecinalesEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<VecinalesEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Fotos Lista */}
                  <Route path="fotos" element={<Wrapper />}>
                    <Route index element={<FotosListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<FotosListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Fotos Crear */}
                  <Route path="crearfotos" element={<Wrapper />}>
                    <Route index element={<FotosCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<FotosCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Fotos Editar */}
                  <Route path="editarfotos" element={<Wrapper />}>
                    <Route index element={<FotosEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<FotosEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusiones de visita domiciliaria Lista */}
                  <Route path="conclusionesDom" element={<Wrapper />}>
                    <Route index element={<ConclusionesDomListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDomListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusiones de visita domiciliaria Crear */}
                  <Route path="crearconclusionesDom" element={<Wrapper />}>
                    <Route index element={<ConclusionesDomCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDomCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusiones de visita domiciliaria Editar */}
                  <Route path="editarconclusionesDom" element={<Wrapper />}>
                    <Route index element={<ConclusionesDomEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDomEditarScreen />}
                    />
                  </Route>

                  {/* Descargar formularios Visita Domiciliaria Lista */}
                  <Route path="descargarVD" element={<Wrapper />}>
                    <Route index element={<DescargarFormulariosVD_print />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<DescargarFormulariosVD_print />}
                    />
                  </Route>

                  {/* Ruta de Autorización al Proceso de Evaluaciones de Detección de Riesgos Lista*/}
                  <Route path="autorizacionDR" element={<Wrapper />}>
                    <Route index element={<AutorizacionDRListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionDRListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion al Proceso de Evaluaciones de Detección de Riesgos Crear*/}
                  <Route path="crearAutDR" element={<Wrapper />}>
                    <Route index element={<AutorizacionDRCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionDRCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion al Proceso de Evaluaciones de Detección de Riesgos Editar*/}
                  <Route path="editarAutDR" element={<Wrapper />}>
                    <Route index element={<AutorizacionDREditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionDREditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusiones de Evaluaciones de Detección de Riesgos Lista */}
                  <Route path="conclusionesDR" element={<Wrapper />}>
                    <Route index element={<ConclusionesDRListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDRListaScreen />}
                    />
                    {/* Aqui va a ser ConclusionesDRListaScreen*/}
                  </Route>

                  {/* Ruta de Conclusiones de Evaluaciones de Detección de Riesgos Crear */}
                  <Route path="crearconclusionesDR" element={<Wrapper />}>
                    <Route index element={<ConclusionesDRCrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDRCrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusiones de Evaluaciones de Detección de Riesgos */}
                  <Route path="editarconclusionesDR" element={<Wrapper />}>
                    <Route index element={<ConclusionesDREditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesDREditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Reporte General del Área de Análisis de Información Lista */}
                  <Route path="resultadoGeneralRGAAI" element={<Wrapper />}>
                    <Route index element={<ResultadoGeneralRGAAI />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ResultadoGeneralRGAAI />}
                    />
                  </Route>

                  {/* Ruta de Reporte General del Área de Análisis de Información Crear */}
                  <Route
                    path="crearResultadoGeneralRGAAI"
                    element={<Wrapper />}
                  >
                    <Route index element={<ResultadoGeneralRGAAI />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ResultadoGeneralRGAAICrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Reporte General del Área de Análisis de Información Lista */}
                  <Route
                    path="editarResultadoGeneralRGAAI"
                    element={<Wrapper />}
                  >
                    <Route index element={<ResultadoGeneralRGAAI />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ResultadoGeneralRGAAIEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Otras Evaluaciones Lista */}
                  <Route path="otras_evaluacionesLinea" element={<Wrapper />}>
                    <Route index element={<OtrasEvaluacionesListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<OtrasEvaluacionesListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion Otras Evaluaciones Lista */}
                  <Route path="autorizacionOE" element={<Wrapper />}>
                    <Route index element={<AutorizacionOEListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionOEListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion Otras Evaluaciones Crear */}
                  <Route path="crearAutorizacionOE" element={<Wrapper />}>
                    <Route index element={<AutorizacionOECrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionOECrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Autorizacion Otras Evaluaciones Editar */}
                  <Route path="editarAutorizacionOE" element={<Wrapper />}>
                    <Route index element={<AutorizacionOEEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<AutorizacionOEEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Otras Evaluaciones Lista */}
                  <Route path="conclusionOE" element={<Wrapper />}>
                    <Route index element={<ConclusionesOEListaScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesOEListaScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Otras Evaluaciones Crear */}
                  <Route path="crearConclusionOE" element={<Wrapper />}>
                    <Route index element={<ConclusionesOECrearScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesOECrearScreen />}
                    />
                  </Route>

                  {/* Ruta de Conclusión de Otras Evaluaciones Editar */}
                  <Route path="editarConclusionOE" element={<Wrapper />}>
                    <Route index element={<ConclusionesOEEditarScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ConclusionesOEEditarScreen />}
                    />
                  </Route>

                  {/* Ruta de Envio de Resultados en linea Lista */}
                  <Route path="envio_resultadosLinea" element={<Wrapper />}>
                    <Route
                      index
                      element={<EnvioResultadosLineaListaScreen />}
                    />
                    <Route
                      path=":evaluadosList_id"
                      element={<EnvioResultadosLineaListaScreen />}
                    />
                  </Route>

                  {/* Rutas de los Modulos Presencial */}
                  <Route path="modulos_presenciales" element={<Wrapper />}>
                    <Route index element={<ModulosListaPresnecialScreen />} />
                    <Route
                      path=":evaluadosList_id"
                      element={<ModulosListaPresnecialScreen />}
                    />
                  </Route>

                  {/* Ruta de Formatos Generales presencial */}
                  <Route path="documentos_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<DocumentosListaPresencialScreen />}
                    />
                  </Route>

                  {/* Ruta de Formatos Generales presencial */}
                  <Route path="formatos_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<FormatosListaPresencialScreen />}
                    />
                  </Route>

                  {/* Ruta de Visita domiciliaria presencial */}
                  <Route path="domiciliaria_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<DomiciliariaListaPresencialScreen />}
                    />
                  </Route>

                  {/* Ruta de Área de análisis de Información presencial */}
                  <Route path="informacion_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<AnalisisDeInformacionListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Evaluación Psicológica presencial */}
                  <Route path="psicologica_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PsicologicaListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Evaluación Psicométrica presencial */}
                  <Route path="psicometrica_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PsicometricaListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Evaluación Médica presencial */}
                  <Route path="medica_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<MedicaListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Investigación Socioeconómica presencial */}
                  <Route path="socioeconomica_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<SocioeconomicaListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Investigación Toxicológica presencial */}
                  <Route path="toxicologica_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<ToxicologicaListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Evaluación de Deteccion de Riesgos presencial */}
                  <Route path="poligrafo_presencial" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<DeteccionRiesgosListaPresencialScreen />}
                    />
                  </Route>
                  {/* Ruta de Otras Evaluaciones presencial */}
                  <Route path="otras_evaluaciones" element={<Wrapper />}>
                    <Route
                      path=":evaluadosList_id"
                      element={<OtrasEvaluacionesListaPresencial />}
                    />
                  </Route>
                  {/* Ruta de Envio de Resultados presencial */}
                  <Route
                    path="envio_resultadosPresencial"
                    element={<Wrapper />}
                  >
                    <Route
                      path=":evaluadosList_id"
                      element={<EnvioDeResultadosListaPresencial />}
                    />
                  </Route>
                  {/*Ruta de Poligrafo presencial*/}
                  <Route 
                    path="poligrafia_presencial" 
                    element={<Wrapper/>}>
                    <Route
                      path=":evaluadosList_id"
                      element={<PoligrafoPresencial/>}
                    />  
                  </Route>
                  {/*Ruta de Eyedetc presencial*/}
                  <Route
                    path="eyedetc_presencial"
                    element={<Wrapper/>}
                  >
                    <Route
                      path=":evaluadosList_id"
                      element={<EyedetcPresencial/>}
                    />
                  </Route>
                  {/*Ruta de VeriEye presencial*/}
                  <Route
                    path="verieye_presencial"
                    element={<Wrapper/>}
                  >
                    <Route
                      path=":evaluadosList_id"
                      element={<VeriEyePresencial/>}
                    />
                  </Route>
                  {/*Ruta de Voice Stress Analysis*/}
                  <Route
                    path="voice_stress_analysis"
                    element={<Wrapper/>}
                  >
                    <Route
                      path=":evaluadosList_id"
                      element={<VoiceStressAnalysis/>}
                    />
                  </Route>

                  {/* Rutas de Reporte Final Presencial */}
                  <Route path="evaluaciones/presencial/reporte-final" element={<Wrapper />}>
                    <Route path=":evaluadosList_id" element={<ReporteFinalPresencial />} />
                  </Route>
                  <Route path="evaluaciones/presencial/reporte-final/crear" element={<Wrapper />}>
                    <Route path=":evaluadosList_id" element={<CrearReporteFinalPresencial />} />
                  </Route>
                  <Route path="evaluaciones/presencial/reporte-final/editar" element={<Wrapper />}>
                    <Route path=":evaluadosList_id" element={<EditarReporteFinalPresencial />} />
                  </Route>
                  <Route path="evaluaciones/presencial/reporte-final/imprimir" element={<Wrapper />}>
                    <Route path=":evaluadosList_id" element={<ReporteFinalPresencialPrint />} />
                  </Route>
                  <Route path="evaluaciones/presencial/reporte-final/lista" element={<Wrapper />}>
                    <Route path=":evaluadosList_id" element={<ReporteFinalPresencialListaScreen />} />
                  </Route>

                </>
              ) : (
                /* RUTAS PARA USUARIOS NO AUTENTICADOS */
                <>
                  <Route path="/login" element={<LoginScreen />} />
                  <Route path="*" element={<Navigate to="/login" />} />
                </>
              )}
            </Routes>
          </div>
          {/* Componente para las alertas */}
          <ToastContainer
            position="top-left"
            autoClose={3000}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            pauseOnHover={false}
            draggable={false}
            theme="light"
          />
        </BloquesProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
